import PropTypes from "prop-types";
import _str from "shared/util/_str";
import invert from "lodash/invert";

export const FIELDS = {
	POLITICS: "politics",
	EMPLOYMENT: "employment",
	EDUCATION: "education",
	RELIGION: "religion",
	LANGUAGES: "languages",
	HEIGHT: "height",
	HAVE_KIDS: "have kids",
	WANT_KIDS: "want kids",
	ETHNICITY: "ethnicity",
	PETS: "pets",
	DIET: "diet",
	MARIJUANA: "marijuana",
	CONNECTION_TYPE: "connection_type",
	SMOKING: "smoking",
	DRINKING: "drinking",
	DISTANCE: "distance",
	AGE: "age",
	ORIENTATION: "orientation",
	SIGNS: "signs",
	GENDER: "gender",
	BODY_TYPE: "body_type",
	RELATIONSHIP_STATUS: "relationship_status",
};

export const FIELD_CATEGORIES = {
	BACKGROUND: "background",
	FAMILY: "family",
	BASICS: "basics",
	LIFESTYLE: "lifestyle",
	LOOKS: "looks",
};

export const CATEGORIES_SETTABLE_BEFORE_REBOARDING = [
	FIELD_CATEGORIES.BASICS,
];

export const DROPDOWN_FIELDS = new Set([
	FIELDS.DISTANCE,
]);

export const MINMAX_FIELDS = new Set([
	FIELDS.AGE,
	FIELDS.HEIGHT,
]);

export const BASICS_FIELDS = new Set([
	FIELDS.AGE,
	FIELDS.CONNECTION_TYPE,
	FIELDS.DISTANCE,
	FIELDS.GENDER,
	FIELDS.ORIENTATION,
]);

export const FIELD_TYPES = {
	MIN_MAX: "minmax",
	DROPDOWN: "dropdown",
	CHECKBOXES: "checkboxes",
};

export const FIELDS_BY_BACKEND_ID = {
	107: FIELDS.POLITICS,
	19: FIELDS.EDUCATION,
	8: FIELDS.RELIGION,
	10: FIELDS.HEIGHT,
	112: FIELDS.WANT_KIDS,
	9: FIELDS.ETHNICITY,
	117: FIELDS.PETS,
	54: FIELDS.DIET,
	106: FIELDS.MARIJUANA,
	32: FIELDS.CONNECTION_TYPE,
	11: FIELDS.SMOKING,
	12: FIELDS.DRINKING,
	3: FIELDS.DISTANCE,
	2: FIELDS.AGE,
	21: FIELDS.SIGNS,
	75: FIELDS.GENDER,
	111: FIELDS.HAVE_KIDS,
	76: FIELDS.ORIENTATION,
	114: FIELDS.BODY_TYPE,
	78: FIELDS.LANGUAGES,
	35: FIELDS.RELATIONSHIP_STATUS,
	108: FIELDS.EMPLOYMENT,
};

export const BACKEND_IDS_BY_FIELD = invert(FIELDS_BY_BACKEND_ID);

export const FIELD_PROMPTS = {
	[FIELDS.POLITICS]: _str("What are their political views?"),
	[FIELDS.EMPLOYMENT]: _str("What is their employment status?"),
	[FIELDS.EDUCATION]: _str("What is their level of education?"),
	[FIELDS.RELIGION]: _str("What is their religion?"),
	[FIELDS.HEIGHT]: _str("How tall should they be?"),
	[FIELDS.HAVE_KIDS]: _str("Do they have kid(s)?"),
	[FIELDS.WANT_KIDS]: _str("Do they want kid(s)?"),
	[FIELDS.ETHNICITY]: _str("Preferred Ethnicity"),
	[FIELDS.PETS]: _str("What pet(s) do they have?"),
	[FIELDS.DIET]: _str("What do they eat?"),
	[FIELDS.MARIJUANA]: _str("How often do they consume marijuana?"),
	[FIELDS.CONNECTION_TYPE]: _str("What connections are you looking for?"),
	[FIELDS.SMOKING]: _str("How often do they smoke cigarettes?"),
	[FIELDS.DRINKING]: _str("How often do they drink alcohol?"),
	[FIELDS.DISTANCE]: _str("How far away should they live?"),
	[FIELDS.AGE]: _str("How old should they be?"),
	[FIELDS.ORIENTATION]: _str("I am looking for…"),
	[FIELDS.SIGNS]: _str("What is their astrological sign?"),
	[FIELDS.GENDER]: _str("I am looking for…"),
	[FIELDS.BODY_TYPE]: _str("What is their body type?"),
	[FIELDS.LANGUAGES]: _str("What language(s) do they speak?"),
	[FIELDS.RELATIONSHIP_STATUS]: _str("Their status"),
};

export const CATEGORY_LABELS = {
	[FIELD_CATEGORIES.BACKGROUND]: _str("Background Preferences"),
	[FIELD_CATEGORIES.FAMILY]: _str("Family"),
	[FIELD_CATEGORIES.BASICS]: _str("Basics"),
	[FIELD_CATEGORIES.LIFESTYLE]: _str("Lifestyle"),
	[FIELD_CATEGORIES.LOOKS]: _str("Looks"),
};

export const PREFERENCE_TYPES = {
	SORT: 2,
	BASICS: 0,
};

const OPTIONS_PROP_TYPES = PropTypes.arrayOf(
	PropTypes.shape({
		is_selected: PropTypes.bool,
		name: PropTypes.string,
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}));

export const CATEGORY_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
	category_id: PropTypes.string.isRequired,
	category_preferences: PropTypes.arrayOf(PropTypes.shape({
		options: OPTIONS_PROP_TYPES,
		name: PropTypes.string.isRequired,
		id: PropTypes.number.isRequired,
		any_option: PropTypes.string,
	})).isRequired,
}));

const PREFERENCE_PROP_TYPE = PropTypes.shape({
	options: OPTIONS_PROP_TYPES,
	name: PropTypes.string.isRequired,
	id: PropTypes.number.isRequired,
	max: PropTypes.number,
	min: PropTypes.number,
	category: PropTypes.string,
	fieldName: PropTypes.string.isRequired,
	fieldType: PropTypes.string,
});

export const PREFERENCES_PROP_TYPE = PropTypes.shape(Object.keys(FIELDS_BY_BACKEND_ID)
	.reduce((types, id) => ({
		...types,
		[id]: PREFERENCE_PROP_TYPE,
	}), {}));



// WEBPACK FOOTER //
// ./src/apps/global_preferences/util/constants.js